import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import uuid from 'uuid/v1';
import {
	Card,
	CardHeader,
	CardContent,
	CardActions,
	Divider,
	Button,
	Grid,
	TextField,
	Checkbox,
	Autocomplete
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import _ from 'underscore';
import moment from 'moment';
import { Page, Header, Alert } from 'components';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { TopOffendersCitiesForm } from './components';
import { PerformanceCitiesRequest, SetFormState } from '../actions/TopOffendersCitiesActions';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	sitelist: {
		marginTop: theme.spacing(6)
	}
}));

const DumpExport = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.TopOffendersCitiesReducers.formState);

	useEffect(() => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				cities: '',
				startDate: null,
				endDate: null
			},
			touched: {
				...formState.touched,
				cities: false
			}
		});
	}, []);

	return (
		<Page className={classes.root} title="Top Offenders">
			<Header module="Top Offenders" view="Cities Performance Monitoring" />
			<TopOffendersCitiesForm />
		</Page>
	);
};

export default DumpExport;
